import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';

export const removeCustomPanelPageMenuItem = (): ContextMenuList => {
	return {
		type: ContextMenuListItemType.Item,
		content: 'Remove Page',
		onClick: ({ context, controller }): void => {
			controller.publishRequestedAction('remove_custom_panel_page', context.id);
		}
	};
};
